function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.488,7.618,16,2.134A.446.446,0,0,0,15.689,2H7.93a.446.446,0,0,0-.315.131L2.131,7.618A.446.446,0,0,0,2,7.93v7.758A.446.446,0,0,0,2.131,16l5.484,5.484a.446.446,0,0,0,.315.131h7.758A.446.446,0,0,0,16,21.488L21.488,16a.446.446,0,0,0,.131-.315V7.93A.446.446,0,0,0,21.488,7.618ZM11.809,18.052a.892.892,0,1,1,.892-.892A.892.892,0,0,1,11.809,18.052Zm.466-3.491h-.915l-.443-9.223h1.8Z",
  transform: "translate(-2 -2)",
  fill: "#fff"
})));

var SvgAlert4 = function SvgAlert4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.619,
    height: 19.619,
    viewBox: "0 0 19.619 19.619",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-4.59264491.svg";
export { ForwardRef as ReactComponent };